// removed by extract-text-webpack-plugin
module.exports = {"Modal":"Modal__Modal__cd320"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Modal/Modal.css
// module id = 107
// module chunks = 3